import type { BiomeKind } from '../generated/BiomeKind';

export function biomeLabel(biome: BiomeKind): string {
  return biome.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export function dominantBiome(biomes: BiomeKind[]): BiomeKind | null {
  if (biomes.length === 0) return null;
  const counts = new Map<BiomeKind, number>();
  for (const b of biomes) {
    counts.set(b, (counts.get(b) ?? 0) + 1);
  }
  let best: BiomeKind = biomes[0]!;
  let bestCount = 0;
  for (const [biome, count] of counts) {
    if (count > bestCount) {
      best = biome;
      bestCount = count;
    }
  }
  return best;
}
